import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,  
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  TextField,
} from "@material-ui/core";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../api/DnerhsApi";
import FormInput from "../../../Controls/Input";
import FormDatePicker from "../../../Controls/DatePicker";
import FormSelect from "../../../Controls/Select";
import Alert from "../../../components/Alert";
import history from "../../../utils/History";
import { useParams, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/Auth";
import Roles from "../../../constants/Roles";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AdjuntosDialog from "../../../dialogs/AdjuntosDialog";
import commonMethods from "../../../utils/commonMethods";
import { findByNumeroCedula } from "services/DatosPersonalesService";
import { getCarrerasProgramas, getEstudiante } from "services/ConvenioService";
import { getAll as getAllNacionalidades } from "services/NacionalidadService";
import { getAll as getAllGeneros } from "services/GeneroService";
import { trackPromise } from "react-promise-tracker";
import ResponseUtils from "../../../utils/ResponseUtils";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
}));

const Form = () => {
  const classes = useStyles();
  const [carreraOptions, setCarreraOptions] = useState([]);
  const [nacionalidadOptions, setNacionalidadOptions] = useState([]);
  const [generoOptions, setGeneroOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCedulaExtranjera, setIsCedulaExtranjera] = useState(true);
  const [isDisabledCedulaExtranjera, setIsDisabledCedulaExtranjera] = useState(true);

  const [isReadOnly, setIsReadOnly] = useState(false);

  const [estudianteResponseData, setEstudianteResponseData] = useState({});
  const [documentsOptions, setDocumentsOptions] = useState({
    bioseguridad: {
      tittle: "Capacitación en Bioseguridad",
      disabled: isReadOnly
    },
    contrato: {
      tittle: "Contrato",
      disabled: isReadOnly
    },
    radicacionPermiso: {
      tittle: "Permiso de Radicación",
      disabled: isReadOnly
    },
  });
  const [open, setOpen] = useState(false);
  const [uploadDialogTittle, setUploadDialogTittle] = useState("");
  const [documentSelectedKey, setDocumentSelectedKey] = useState("");
  const params = useParams();
  const methods = useForm({});
  const { handleSubmit, errors, setValue, reset } = methods;
  const { hasRole } = useAuth();
  let { state } = useLocation();
  const [idEstudiante, setIdEstudiante] = useState();
  const [fechaCreacion, setFechaCreacion] = useState();
  const [usuarioCreacion, setUsuarioCreacion] = useState();
  const [documentoExtranjero, setDocumentoExtranjero] = useState("no");
  const [postgradoId, setPostgradoId] = useState();
  const [isPostgrado, setIsPostgrado] = useState(false);

  useEffect(() => {
    const load = () => {
      try {
        if (state?.edit || state?.readOnly) {
          setIsUpdate(state?.edit);
          setIsReadOnly(state?.readOnly);
          setValuesForEdit();
        } else {
          getServerData({ convenioId: params.convenioId });
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async ({ convenioId }) => {
    try {
      const [responseCarreraPrograma, responseNacionalidad, responseGenero] =
        await Promise.all([
          getCarrerasProgramas(convenioId),
          getAllNacionalidades(),
          getAllGeneros(),
        ]);

      loadCarreraOptions(responseCarreraPrograma?.data);
      loadNacionalidadOptions(responseNacionalidad.data);
      loadGeneroOptions(responseGenero.data);
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const handleClickOpen = (documentKey) => {
    setUploadDialogTittle(documentsOptions[documentKey].tittle);
    setDocumentSelectedKey(documentKey);
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);

    let documentOptionsCopy = { ...documentsOptions };
    documentOptionsCopy[documentSelectedKey].id = value;

    setDocumentsOptions({ ...documentOptionsCopy });
    setDocumentSelectedKey("");
  };

  const downloadFile = async (documentKey) => {
    let document = { ...documentsOptions[documentKey] };
    commonMethods.downloadFile(
      `/file/${document.id}`,
      `${documentKey}_${new Date()}`,
      true
    );
  };

    const loadCarreraOptions = (carreras) => {
      if(carreras[0]?.carreraPrograma?.descripcion ==='Postgrado'){
        setIsPostgrado(true);
        setPostgradoId(carreras[0].carreraPrograma.id);
        setCarreraOptions(     
          carreras.map((carrera) => (
          {label: "Postgrado - " +  carrera.nombrePostgrado.descripcion,
          id: carrera.nombrePostgrado.id }
          ))
        );

      }else{
        setCarreraOptions(     
          carreras.map((carrera) => (
          { label: carrera.carreraPrograma.descripcion,
          id: carrera.carreraPrograma.id }
          ))
        );

      } 
  };

  const loadNacionalidadOptions = (nacionalidades) => {
    if (nacionalidades) {
      setNacionalidadOptions(
        nacionalidades.map((nacionalidad) => ({
          label: nacionalidad.nombre,
          id: nacionalidad.id,
        }))
      );
    }
  };

  const loadGeneroOptions = (generos) => {
    if (generos) {
      setGeneroOptions(
        generos.map((genero) => ({
          label: genero.descripcion,
          id: genero.id,
        }))
      );
    }
  };

  const setValuesForEdit = async () => {
    try {
      let { convenioEstudianteId } = params;

      const { data: estudianteResponseData } = await getEstudiante(convenioEstudianteId);
      setEstudianteResponseData(estudianteResponseData);

      await getServerData({ convenioId: estudianteResponseData.convenio.id });
      let { estudiante } = estudianteResponseData;
      setIdEstudiante(estudiante.id);
      setFechaCreacion(estudiante.fechaCreacion);
      setUsuarioCreacion(estudiante.idUsuarioCreacion);
     
      const formValues = {
        cedulaIdentidad: estudiante.cedulaIdentidad,
        fechaNacimiento: estudiante.fechaNacimiento,
        montoCuota : estudiante.montoCuota,
        porcentajeBeca : estudiante.porcentajeBeca,
        nombre: estudiante.nombres,
        apellido: estudiante.apellidos,
        nacionalidad: estudiante.nacionalidad.id,
        sexo: estudiante.sexo.id,
        carrera: estudianteResponseData.carrera.descripcion==="Postgrado"?  estudianteResponseData.nombrePostgrado.id :  estudianteResponseData.carrera.id,
        //carrera: estudianteResponseData.carrera.id,
        curso: estudianteResponseData.curso,
        semestre: estudianteResponseData.semestre,
        materia: estudianteResponseData.materia,
        anio: estudianteResponseData.anio,
       
        bioseguridad: estudiante.bioseguridad,
        radicacionPermiso: estudiante.radicacionPermiso,
        contrato: estudiante.contrato,
        email: estudiante.email,
        documentoExtranjero: estudiante.documentoExtranjero===true? "si": "no"

      };
      setDocumentoExtranjero(estudiante.documentoExtranjero===true? "si": "no");
      setIsCedulaExtranjera(!estudiante.documentoExtranjero);
      let documentsOptionsCopy = {
        ...documentsOptions,
      };

      Object.keys(formValues).forEach((field) => {
        let formValue = formValues[field];

        if (documentsOptionsCopy[field] && formValue != null) {
          documentsOptionsCopy[field].id = formValue;
        } else {
          setValue(field, formValues[field]);
        }
      });

      setDocumentsOptions(documentsOptionsCopy);
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const onSubmit = async (data) => {
    if (!validFormData(data)) {
      return;
    }

    let url = "/convenios/estudiantes";
    let nombrePostgradoIdVar=0;
    const estudianteDataForm = {
      cedulaIdentidad: data.cedulaIdentidad,
      fechaNacimiento: data.fechaNacimiento,
      nombres: data.nombre,
      apellidos: data.apellido,
      nacionalidad: { id: data.nacionalidad },
      sexo: { id: data.sexo },
      contrato: documentsOptions.contrato.id,
      email: data.email,
      montoCuota:data.montoCuota,
      porcentajeBeca:data.porcentajeBeca,
      bioseguridad: documentsOptions.bioseguridad.id,
      radicacionPermiso: documentsOptions.radicacionPermiso.id,
      id: idEstudiante,
      fechaCreacion:fechaCreacion,
      idUsuarioCreacion:usuarioCreacion,
      documentoExtranjero: !isCedulaExtranjera
    };

    try {
      let message = "";

      if (isUpdate) {
        let payloadUpt = { ...estudianteResponseData };

        let estudianteMerge = {
          ...payloadUpt.estudiante,
          ...estudianteDataForm,
        };

        payloadUpt.estudiante = estudianteMerge;
        //payloadUpt.carrera = { id: data.carrera };
        payloadUpt.carrera=isPostgrado? { id: postgradoId } :{ id: data.carrera };

        payloadUpt.curso = data.curso;
        payloadUpt.semestre = data.semestre;
        payloadUpt.materia = data.materia;
        payloadUpt.anio = data.anio;
      
        payloadUpt.nombrePostgrado=isPostgrado? { id: data.carrera } :{ id: nombrePostgradoIdVar };

        await trackPromise(DnerhsApi.put(url, {
          ...payloadUpt,
        }));

        message = "Datos guardados exitosamente.";
      } else {
        let payloadNew = {
          convenio: {
            id: params.convenioId,
          },
          estudiante: estudianteDataForm,
          //carrera: { id: data.carrera },
          carrera: isPostgrado? { id: postgradoId } :{ id: data.carrera },
          curso: data.curso,
          semestre: data.semestre,
          materia: data.materia,
          anio: data.anio,
          
          nombrePostgrado:isPostgrado? { id: data.carrera } :{ id: nombrePostgradoIdVar}
        };

        await trackPromise(DnerhsApi.post(url, {
          ...payloadNew,
        }));

        message = "Datos actualizados exitosamente.";
      }

      Alert.show({
        message,
        type: "success",
      });

      history.goBack();
    } catch (error) {
      console.log(error);
      if (error.response) {
        let message = error.response.data.message;
        Alert.show({
          message,
          type: "error"
        })
      }
    }
  };
  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }
  
    Alert.show({
      message,
      type: "error"
    })
  }
  const validFormData = (data) => {
    if (data.carrera === "") {
      showMessageError("El campo carrera es dato requerido");
      return false;
    }

    if (!documentsOptions.bioseguridad.id) {
      showMessageError(
        "El documento de capacitación de bioseguridad es requerido"
      );
      return false;
    }

    /*if (!documentsOptions.contrato.id) {
      showMessageError("El contrato es un documento requerido");
      return false;
    }
    if (!isCedulaExtranjera && !documentsOptions.radicacionPermiso.id) {
      showMessageError("El documento de permiso de radicación es un documento requerido");
      return false;
    }*/
    return true;
  };

  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error",
    });
  };
  const handleFindDatosEstudiante = async (event) => {
    let { target } = event;
    if(documentoExtranjero==="no"){
      const {data } = await trackPromise(DnerhsApi.get(`/estudiante/cedula/${target.value}`));
        setIdEstudiante("");
        setFechaCreacion("");
        setUsuarioCreacion("");
        setValue("nombre", "");
        setValue("apellido", "");
        setValue("sexo", "");
        setValue("fechaNacimiento",null);
        setValue("nacionalidad", "");
        setValue("carrera", "");
        setValue("curso", "");
        setValue("semestre", "");
        setValue("materia", "");
        setValue("anio", "");
        setValue("montoCuota", "");
        setValue("porcentajeBeca", "");

        setValue("email", "");

      if (data) {
        setIdEstudiante(data.id);
        setFechaCreacion(data.fechaCreacion);
        setUsuarioCreacion(data.idUsuarioCreacion);
        setValue("nombre", data.nombres);
        setValue("apellido", data.apellidos);
        setValue("email", data.email);
        setValue("sexo", data.sexo?.id);
        setValue("fechaNacimiento", data.fechaNacimiento);
        setValue("montoCuota", data.montoCuota);
        setValue("porcentajeBeca", data.porcentajeBeca);
        setValue("nacionalidad", data.nacionalidad.id);
        let documentOptionsCopy = { ...documentsOptions };
        documentsOptions["contrato"].id = data.contrato;
        documentsOptions["bioseguridad"].id = data.bioseguridad;
        setDocumentsOptions({ ...documentOptionsCopy });
        setDocumentoExtranjero('no');
        setIsDisabledCedulaExtranjera(true);
        setIsCedulaExtranjera(true);

      }else{
        handleFindDatosPersonales(target.value);
      }
    }else{
      setIsDisabledCedulaExtranjera(false);
      setValue("nombre", "");
        setValue("apellido", "");
        setValue("sexo", "");
        setValue("fechaNacimiento",null);
        setValue("nacionalidad", "");
        setValue("carrera", "");
        setValue("curso", "");
        setValue("semestre", "");
        setValue("materia", "");
        setValue("anio", "");
        setValue("montoCuota", "");
        setValue("porcentajeBeca", "");
        setValue("email", "");
    }
  };
  const handleFindDatosPersonales = async (event) => {
    //var d = parseInt(event);
    if(!isNaN(event)){
      const { data } = await trackPromise(findByNumeroCedula(event));
      if (data) {
        setValue("nombre", data.nombres);
        setValue("apellido", data.apellidos);
        setValue("sexo", data.genero?.id);
        setValue("fechaNacimiento", data.fechaNacimiento);
        setValue("montoCuota", data.montoCuota);
        setValue("porcentajeBeca", data.porcentajeBeca);
        setDocumentoExtranjero('no');
        setIsDisabledCedulaExtranjera(true);
        setIsCedulaExtranjera(true);
        setValue("nacionalidad", 144);


      }
    }else{
      //setDocumentoExtranjero(null);
      setIsDisabledCedulaExtranjera(false);
      setValue("nombre", "");
        setValue("apellido", "");
        setValue("sexo", "");
        setValue("fechaNacimiento",null);
        setValue("nacionalidad", "");
        setValue("carrera", "");
        setValue("curso", "");
        setValue("semestre", "");
        setValue("materia", "");
        setValue("anio", "");
        setValue("montoCuota", "");
        setValue("porcentajeBeca", "");

        setValue("email", "");

        if(!isUpdate){
         // var message="Si no cuenta con CI paraguaya, elija la opción Cédula Extranjera";
         /* Alert.show({
            message,
            type: "warning",
          });*/
        }      
    }
  };


  const handleRadioChange = ( value) => {

      if (value == 'si') {
        setIsCedulaExtranjera(false);
        setDocumentoExtranjero(value);
        setValue("cedulaIdentidad", "");
        setValue("nombre", "");
        setValue("apellido", "");
        setValue("sexo", "");
        setValue("fechaNacimiento",null);
        setValue("nacionalidad", "");  
       
        setValue("carrera", "");
        setValue("curso", "");
        setValue("semestre", "");
        setValue("materia", "");
        setValue("anio", "");
        setValue("montoCuota", "");
        setValue("porcentajeBeca", "");


        setValue("email", "")
      }else{
        setValue("cedulaIdentidad", "");
        setValue("nombre", "");
        setValue("apellido", "");
        setValue("sexo", "");
        setValue("fechaNacimiento",null);
        setValue("nacionalidad", "");    
         
        setValue("carrera", "");
        setValue("curso", "");
        setValue("semestre", "");
        setValue("materia", "");
        setValue("anio", "");
        setValue("montoCuota", "");
        setValue("porcentajeBeca", "");

        setValue("email", "")    
        setIsDisabledCedulaExtranjera(true);
        setIsCedulaExtranjera(true);
        setDocumentoExtranjero(value);

      }
      
  };



  return (
    <div>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" color="primary">
          Estudiante
        </Typography>
      </Grid>
      <div>
        <FormProvider {...methods}>
          <form>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item xs={6} className={classes.form}>
                <Grid item xs={12} className={classes.field}>
                
                  <FormLabel>Tipo documento</FormLabel>

                  <RadioGroup
                  name="documentoExtranjero"
                    label="Cedula Extranjera"                
                    onChange={(e) =>
                      handleRadioChange(e.target.value)
                    }
                    value={documentoExtranjero}    
                         
                  >
                   
                    <FormControlLabel
                      value="no"                     
                      control={<Radio />}
                      label="Cédula Paraguaya"
                      disabled={isReadOnly}
                      // disabled={isReadOnly  || isDisabledCedulaExtranjera}
                      
                    />
                     <FormControlLabel
                      value="si"
                      control={<Radio />}
                      label="Documento Extranjero"
                      disabled={isReadOnly}
                      // disabled={isReadOnly  || isDisabledCedulaExtranjera}

                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="cedulaIdentidad"
                    label={(documentoExtranjero==="no"? ("Cédula de Identidad Paraguaya"):("Documento Extranjero"))}
                    onBlur={handleFindDatosEstudiante}
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="nombre"
                    label="Nombres"
                    disabled={isCedulaExtranjera}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormSelect
                    name="nacionalidad"
                    label="Nacionalidad"
                    disabled={isCedulaExtranjera}
                    options={nacionalidadOptions}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormSelect
                    name="carrera"
                    label="Carrera"
                    disabled={isReadOnly}
                    options={carreraOptions}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <FormInput
                        name="semestre"
                        label="Semestre"
                        type="number"
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <FormInput
                        name="anio"
                        label="Año"
                        type="number"
                        disabled={isReadOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                 <Grid item xs={12} className={classes.field}>
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <FormInput
                        name="montoCuota"
                        label="Monto Cuota"
                        type="number"
                        defaultValue={0} // Este defaultValue es ignorado por RHF si el campo está registrado
                        disabled={isReadOnly}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      {/* Deshabilita el campo si es de solo lectura o si el estudiante no es becado */}
                      <FormInput 
                        name="porcentajeBeca"
                        label="% Beca"
                        type="number"
                        defaultValue={0} // Este defaultValue es ignorado por RHF si el campo está registrado
                        disabled={isReadOnly }
                      />
                    </Grid>
                 </Grid>
              </Grid>

              </Grid>

              <Grid item xs={6} className={classes.form}>
              <Grid item xs={12} className={classes.field}  style={{visibility: 'hidden'}}  
>
                
                  <FormLabel>Tipo documento</FormLabel>

                  <RadioGroup
                  name="domentoExtranj"
                    label="Cedula Extranjera"                
                    onChange={(e) =>
                      handleRadioChange(e.target.value)
                    }
                    value={documentoExtranjero}    
                  >
                   
                    <FormControlLabel
                      value="no"                     
                      control={<Radio />}
                      label="Cédula Paraguaya"
                      disabled={true}
                      // disabled={isReadOnly  || isDisabledCedulaExtranjera}
                      
                    />
                     <FormControlLabel
                      value="si"
                      control={<Radio />}
                      label="Documento Extranjero"
                      disabled={isReadOnly}
                      // disabled={isReadOnly  || isDisabledCedulaExtranjera}

                    />
                  </RadioGroup>
                </Grid>

               
                <Grid item xs={12} className={classes.field}>
                  <FormDatePicker
                    name="fechaNacimiento"
                    label="Fecha Nacimiento"
                    disabled={isCedulaExtranjera}

                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="apellido"
                    label="Apellidos"
                    disabled={isCedulaExtranjera}

                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormSelect
                    name="sexo"
                    label="Sexo"              
                    options={generoOptions}
                    disabled={isCedulaExtranjera}

                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="curso"
                    label="Curso"
                    type="number"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput
                    name="materia"
                    label="Materia"
                    disabled={isReadOnly}
                  />
                </Grid>
                <Grid item xs={12} className={classes.field}>
                  <FormInput name="email" label="Email" disabled={isReadOnly} />
                </Grid>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </div>
      <Grid container className={classes.form}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            color="primary"
            align="center"
            className={classes.title}
          >
            Adjuntos
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Documento</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documentsOptions &&
                Object.keys(documentsOptions).map((key, index) => (
                  <TableRow key={key}>
                    <TableCell align="left">
                      {documentsOptions[key].tittle}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Subir" aria-label="subir">
                        <span>
                          <IconButton
                            size="small"
                            aria-label="subir"
                            color="primary"
                            disabled={documentsOptions[key].disabled}
                            onClick={() => handleClickOpen(key)}
                          >
                            <CloudUploadIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Ver" aria-label="ver">
                        <span>
                          <IconButton
                            size="small"
                            aria-label="ver"
                            color="secondary"
                            disabled={!documentsOptions[key].id}
                            onClick={() => downloadFile(key)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick={() => history.goBack()}
          >
            Atrás
          </Button>
        </Grid>
        {hasRole(Roles.ROLE_USER) && (
          <Grid item className={classes.field}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </Button>
          </Grid>
        )}
      </Grid>
      <AdjuntosDialog
        open={open}
        onClose={handleClose}
        tipoDoc={uploadDialogTittle}
        aria-labelledby="form-dialog-title"
      />
    </div>
  );
};

export default Form;
